module.exports = __webpack_public_path__ + "img/header-icon-2.34e31287.png";